module.exports = __webpack_public_path__ + "img/audio.67c56802.png";